<app-topnav [employee]="exchangeService.me" [company]="exchangeService.mycompany"></app-topnav>
<app-sidebar></app-sidebar>
<!-- <router-outlet></router-outlet> -->

